import { useCallback } from "react";

import { useFlightFiltersContext } from "@/features/flights/contexts/FlightFiltersContext";
import { useFlightSelectionPayloadContext } from "@/features/flights/contexts/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import type { FlightSearchPagedResultData } from "@/features/flights/hooks/flightSearch/types";
import type { FlightType } from "@/features/flights/types/types";

import {
  useFlightQuickSearchTokens,
  useFlightSearchTokens,
} from "../useFlightSearchTokens";

import { useFlightSearch } from "./useFlightsSearch";
import { getOfferByIdFromSearchResult } from "./utils";

export const useSelectedReturnFlight = () => {
  const {
    selectedReturnFlightId,
    selectedOfferIndex,
    selectedFlightSearchSource,
  } = useFlightSelectionPayloadContext();
  const { query: tokensQuery } = useFlightSearchTokens({
    enabled: selectedFlightSearchSource === "full",
  });
  const quickTokensQuery = useFlightQuickSearchTokens();
  const { filters } = useFlightFiltersContext();

  const select = useCallback(
    (response: FlightSearchPagedResultData) => {
      const selectedOffer = getOfferByIdFromSearchResult(
        response,
        selectedOfferIndex,
      );
      if (!selectedOffer) return undefined;

      const selectedReturnFlight = selectedOffer.flightsOverview.find(
        (fo) => fo.returnFlight?.key === selectedReturnFlightId,
      )?.returnFlight;

      return selectedReturnFlight;
    },
    [selectedReturnFlightId, selectedOfferIndex],
  );

  return useFlightSearch<FlightType | undefined>(
    selectedFlightSearchSource === "quick" ? quickTokensQuery : tokensQuery,
    filters,
    {
      select,
    },
  );
};
